/*
  Without container blocking click propagation opens the order detail but with it
  gives problems with consecutive clicks to the same checkbox and the response time
  of the Checkbox handler is very slow, moving the handler to the container div solves
  these problems.
 */
import React, { useCallback } from 'react';
import { Checkbox } from '@ontruck/orc';

const GroupSelector = ({ className, isSelected, setSelected, journeyId }) => {
  const handleCheckboxChange = useCallback(
    (e) => {
      e.stopPropagation();
      e.preventDefault();

      if (!isSelected) return setSelected((current) => [...current, journeyId]);
      return setSelected((current) => current.filter((id) => id !== journeyId));
    },
    [journeyId, isSelected, setSelected]
  );

  return (
    <div className={className} onClick={handleCheckboxChange}>
      <Checkbox
        name="GroupSelectorCheckbox"
        checked={isSelected}
        onChange={() => {
          /*noop*/
        }}
      />
    </div>
  );
};

export default GroupSelector;
